import React, {useEffect} from 'react';
import {
  withAnalytics,
  useAnalytics,
} from '@lexus.com/ui/dist/components/analytics';
import { useBreakpointName } from '@lexus.com/ui/dist/components/breakpoints';
import { usePersonalizedContext } from '@lexus.com/ui/dist/packages/personalization';
const withGlobalAnalytics = Component => {
  return (props) => {
    const breakpoint = useBreakpointName();
    const _personalization = usePersonalizedContext();
    return (
      <Component
        breakpoint={breakpoint}
        _personalization={_personalization}
        {...props}
      />
    );
  }
}

// Todo: this can live at the top level once Legacy Analytics Provider is removed
const AppAnalytics = withGlobalAnalytics(withAnalytics(({children}) => {
  const fireAnalytics = useAnalytics('App');

  useEffect(() => {
    fireAnalytics('pageload');
  }, []);

  return (<>{children}</>);
})({
  _component: 'App',
}));

export default AppAnalytics;
